import { render, staticRenderFns } from "./tableItems.vue?vue&type=template&id=1296d66e&scoped=true"
import script from "./tableItems.vue?vue&type=script&lang=js"
export * from "./tableItems.vue?vue&type=script&lang=js"
import style0 from "./tableItems.vue?vue&type=style&index=0&id=1296d66e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1296d66e",
  null
  
)

export default component.exports